import { formatPrice } from '@grandvisionhq/utils';

// returns discounted value as either `-€##` or `-##%`
const getDiscount = (prices, locale)=>{
    var ref, ref1;
    if (!Array.isArray(prices) || !prices[0]) {
        return undefined;
    }
    const { discounted  } = prices[0];
    // check that discounted contains discount object
    if (!discounted || !((ref = discounted.discount) === null || ref === void 0 ? void 0 : ref.obj)) return undefined;
    const { value , isActive  } = (ref1 = discounted.discount) === null || ref1 === void 0 ? void 0 : ref1.obj;
    return value.type === 'absolute' ? getAbsoluteDiscount(value, isActive, locale) : getRelativeDiscount(value, isActive);
};
// gets absolute discount value (in currency)
const getAbsoluteDiscount = (value, isActive, locale)=>{
    if (!value.money[0]) {
        return undefined;
    }
    const { centAmount , currencyCode  } = value.money[0];
    if (centAmount === 0 || !isActive) return undefined;
    return `-${formatPrice({
        locale,
        value: centAmount,
        currency: currencyCode,
        isCentAmount: true
    })}`;
};
// gets relative discount value (in percentage)
const getRelativeDiscount = (value, isActive)=>value.permyriad !== 0 && isActive ? `-${value.permyriad / 100}%` : undefined
;

export { getDiscount };
//# sourceMappingURL=get-discount.js.map
